'use strict'
import uniqBy from 'lodash/uniqBy';
import assign from 'lodash/assign';
import reject from 'lodash/reject';

/**
 * Shorthand for session storage management
 * @param {string} action get, set, remove
 * @param {string} key property to get from session storage
 * @param {*} value only for set action. Any data.
 * @returns object from session storage
 */
export const sesStorage = (action, key, value) => {
	let res;
	switch (action) {
		case 'get':
			try {
				res = JSON.parse(sessionStorage.getItem(key));
			} catch (e) {
				res = sessionStorage.getItem(key);
			}
			break;
		case 'set':
			if (sesStorage('get', key)) {
				let oldValue = sesStorage('get', key);
				let newValue = value;
				if (typeof(value) === 'object') {
					sessionStorage.setItem(key, JSON.stringify(assign({}, oldValue, newValue)));
				}
				if (Array.isArray(value)) {
					if (oldValue.id === newValue.id) {
						oldValue = reject(oldValue, function(el) { return el.id === newValue.id; });
					}
					let uniqueArray = uniqBy([...oldValue, ...newValue], 'id');
					sessionStorage.setItem(key, JSON.stringify(uniqueArray));
				}
			} else {
				sessionStorage.setItem(key, JSON.stringify(value));
			}
			break;
		case 'remove':
			sessionStorage.removeItem(key);
			break;
	}
	return res;
}
